import { NgModule } from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {LoginComponent} from './views/login/login.component';
import {ComponentCanDeactivateGuardService} from './services/componentCanDeactivate';
import {RSLoadingDeactivateGuardService} from '../libs/rsloading/rsloading.service';
import {SharedModule} from './shared.module';
import {FirebaseAuthResolver, FirebaseAwaitResolver} from './services/firebase-auth-resolver';
import {HomeComponent} from './views/home/home.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SettingsComponent} from './views/settings/settings.component';
import {ReportsComponent} from './views/reports/reports.component';
import {GrowersComponent} from './views/growers/growers.component';
import {GrowerComponent} from './views/grower/grower.component';
import {ActivitiesComponent} from './views/activities/activities.component';
import {EventsComponent} from './views/events/events.component';
import {GrowerSearchComponent} from './views/grower-search/grower-search.component';
import {AddContactComponent} from './views/add-contact/add-contact.component';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {AddCategoryComponent} from './views/add-category/add-category.component';
import {ColorCompactModule} from 'ngx-color/compact';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {AddActivityComponent} from './views/add-activity/add-activity.component';
import {AddEventComponent} from './views/add-event/add-event.component';
import {GrowerRecentComponent} from './views/grower-recent/grower-recent.component';
import {ViewEventComponent} from './views/view-event/view-event.component';
import {CategoryTagComponent} from './views/category-tag/category-tag.component';
import {PracticeChangeWaterComponent} from './views/practice-change-water/practice-change-water.component';
import {PracticeChangeFertiliserComponent} from './views/practice-change-fertiliser/practice-change-fertiliser.component';
import {PracticeChangePesticideComponent} from './views/practice-change-pesticide/practice-change-pesticide.component';
import {PracticeChangeSoilsComponent} from './views/practice-change-soils/practice-change-soils.component';
import {HighchartsChartModule} from 'highcharts-angular';
import {GrowerOthersComponent} from './views/grower-others/grower-others.component';
import {UpdatePropertyContactComponent} from './views/update-property-contact/update-property-contact.component';
import {OtherContactsComponent} from './views/other-contacts/other-contacts.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ButtonTagComponent} from "./views/button-tag/button-tag.component";
import {AddAssistanceTypeComponent} from "./views/add-assistance-type/add-assistance-type.component";
import {AddARiskTypeComponent} from "./views/add-risk-type/add-risk-type.component";
import {MeetingsComponent} from "./views/meetings/meetings.component";
import {AddMeetingComponent} from "./views/add-meeting/add-meeting.component";
import {ViewMeetingComponent} from "./views/view-meeting/view-meeting.component";
import {AddAssistanceComponent} from "./views/add-assistance/add-assistance.component";
import {AddPracticeChangeActivityComponent} from "./views/add-practice-change-activity/add-practice-change-activity.component";
import {AddPracticeChangeComponent} from "./views/add-practice-change/add-practice-change.component";

const routes: Routes = [
  {
    path: 'login',
    redirectTo: '',
  },
  {
    path: '',
    component: LoginComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbawait: FirebaseAwaitResolver }
  },
  {
    path: 'home',
    component: HomeComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: 'growers',
    component: GrowersComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: 'growers/:id',
    component: GrowerComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: 'events',
    component: EventsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: 'events/:id',
    component: EventsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },

  {
    path: 'meetings',
    component: MeetingsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },

  {
    path: 'meetings/:id',
    component: MeetingsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },

  {
    path: 'contacts',
    component: OtherContactsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  // {
  //   path: 'practice',
  //   component: PracticeChangeComponent,
  //   canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
  //   resolve: { fbauth: FirebaseAuthResolver }
  // },
  // {
  //   path: 'activities',
  //   component: ActivitiesComponent,
  //   canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
  //   resolve: { fbauth: FirebaseAuthResolver }
  // },
  {
    path: 'reports',
    component: ReportsComponent,
    canDeactivate: [ComponentCanDeactivateGuardService, RSLoadingDeactivateGuardService],
    resolve: { fbauth: FirebaseAuthResolver }
  },
  {
    path: '**',
    component: LoginComponent,
    resolve: { fbawait: FirebaseAwaitResolver }
  }
];

@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    SettingsComponent,
    ReportsComponent,
    GrowersComponent,
    GrowerComponent,
    EventsComponent,
    ActivitiesComponent,
    GrowerSearchComponent,
    GrowerRecentComponent,
    AddContactComponent,
    AddCategoryComponent,
    AddActivityComponent,
    AddEventComponent,
    ViewEventComponent,
    CategoryTagComponent,
    ButtonTagComponent,
    OtherContactsComponent,

    GrowerOthersComponent,
    UpdatePropertyContactComponent,

    PracticeChangeWaterComponent,
    PracticeChangeFertiliserComponent,
    PracticeChangePesticideComponent,
    PracticeChangeSoilsComponent,

    AddAssistanceTypeComponent,
    AddARiskTypeComponent,
    MeetingsComponent,
    AddMeetingComponent,
    ViewMeetingComponent,
    AddAssistanceComponent,
    AddPracticeChangeActivityComponent,
    AddPracticeChangeComponent,
  ],
    imports: [
        RouterModule.forRoot(routes,
            {
                      enableTracing: false,
                      anchorScrolling: 'enabled',
                      scrollPositionRestoration: 'top',
                      preloadingStrategy: PreloadAllModules
                  }
        ),
        SharedModule,
        FormsModule,
        NgxMatDatetimePickerModule,
        ColorCompactModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        HighchartsChartModule,
        MatSlideToggleModule
    ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
